import React from "react";

export default function GenerateImg({ url, alt }) {
  return <img src={url} alt={alt} />;
}
